import { FormWithRedux } from '../../FormWithRedux';

export class ACCBISTSuspectedFractureForm extends FormWithRedux {

    constructor(parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super('suspectedFractureSubform', parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);

        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory(identifier) {
        if (identifier == 'depressedSkullFracture' || identifier == 'openSkullFracture' || identifier == 'basalSkullFracture') {
            return this.getValue('suspectedSkullFracture') == true;
        }

        return true;
    }

    getValueType(identifier) {
        if (identifier == 'depressedSkullFracture' || identifier == 'openSkullFracture' || identifier == 'basalSkullFracture') {
            return 'boolean';
        }

        return null;
    }

    submissionValidation() {
        return [];
    }

    editingValidation(identifier) {
        return [];
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/Forms/ACCBIST-SuspectedFractureForm.js